import script from "./EventsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsDashboard.vue?vue&type=script&setup=true&lang=js"

import "./EventsDashboard.vue?vue&type=style&index=0&id=2e7c7471&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e7c7471"]])

export default __exports__